import AppService from './AppService';

class StateService extends AppService {
  constructor() {
    super();
    this.path = this.getPath('states');
  }

  list(params = '') {
    const queryParams = params ? params : '';
    return this.http.get(`${this.path}${queryParams}`);
  }
  zipCode(id) {
    return this.http.get(`${this.path}/${id}`);
  }
  zip(zip) {
    return this.http.get(`web/zip/${zip}`);
  }
}

export default StateService;
